// 孵化器
import { Form } from 'antd';
import IncubatorList from './base/Index';
import IncubatorAdd from './base/PageAdd';
import IncubatorEdit from './base/PageEdit';
import IncubatorSeatList from './seat/Index';
import IncubatorAddressList from './address/Index';
import IncubatorAddressedList from './address/PageUseDetail';
import IncubatorOne from './one/Index';
import IncubatorOneContract from './one/PageContract';
import IncubatorOneBill from './one/PageBill';
import IncubatorOneCustom from './one/PageCustom';
import IncubatorOneOregistapp from './one/PageOregistapp';
// import IncubatorOneFinance from "./one/PageFinance";
import IncubatorOneInvestment from './one/PageInvestment';

import IncuContractAddress from './contract/address/PageAddress';
import IncuContractStation from './contract/station/PageStation';
import contractTermination from './contract/end/PageEnd';
import addressTermination from './contract/end/PageAddressEnd';
import IncuContractInfo from './contract/detail/Index';
import IncuContractAddressInfo from './contract/detail/PageAddressDetail';
import IncuContractOtherInfo from './contract/detail/PageOtherDetail';
import PageIncuDiscount from './one/PageDiscount';
import IncuContractWorkbench from './workbench/Index';

import IncuSettledMine from './settled/PageMine';
import IncuSettledWatch from './settled/PageWatch';
import IncuSettledOpen from './settled/PageInfo';

import IncuOregistappMine from './oregistapp/PageMine';
import IncuOregistappWatch from './oregistapp/PageWatch';
import IncuOregistappOpen from './oregistapp/PageInfo';

import IncuOregistappMoveOutMine from './oregistappMoveOut/PageMine';
import IncuOregistappMoveOutWatch from './oregistappMoveOut/PageWatch';
import IncuOregistappMoveOutOpen from './oregistappMoveOut/PageInfo';
import IncuOregistappMoveOutAdd from './oregistappMoveOut/PageAdd';

import IncuTerminationMine from './termination/PageMine';
import IncuTerminationWatch from './termination/PageWatch';
import IncuTerminationOpen from './termination/PageInfo';

import IncuBillDetail from './bill/PageDetail';

import IncuCustomList from './custom/Index';
import IncuCustomDetail from './custom/detail/PageDetail';
import IncuCustomBase from './custom/base/Index';
import IncuBillList from './bill/Index';
import IncuIncomeList from './income/Index';
import IncuContractList from './contract/index/Index';

// 财务分析
import AnalyzeExpend from './analyze/expend/Index';
import AnalyzeBudget from './analyze/budget/Index';
import AnalyzeIncome from './analyze/income/Index';
import AnalyzeTrace from './analyze/profit/Index';
import AnalyzeOther from './analyze/notContract/Index';

// 退款
import BackAdd from './back/PageAdd';
import IncuBackMine from './back/PageMine';
import IncuBackWatch from './back/PageWatch';
import IncuBackOpen from './back/PageInfo';

// 地址释放
import ReleaseAdd from './release/PageAdd';
import IncuReleaseMine from './release/PageMine';
import IncuReleaseWatch from './release/PageWatch';
import IncuReleaseOpen from './release/PageInfo';

// 错款退还
import RefundAdd from './refund/PageAdd';
import IncuRefundMine from './refund/PageMine';
import IncuRefundWatch from './refund/PageWatch';
import IncuRefundOpen from './refund/PageInfo';

// 开票
import InvoiceAdd from './invoice/PageAdd';
import InvoiceIndex from './invoice/PageCustom';
import Manage from './invoice/PageCustomInvoice';
import IncuInvoiceMine from './invoice/PageMine';
import IncuInvoiceWatch from './invoice/PageWatch';
import IncuInvoiceOpen from './invoice/PageInfo';

const router = {
  path: 'incubator',
  breadcrumbName: '孵化器',
  indexRoute: { component: IncubatorList },
  childRoutes: [
    {
      path: 'one/:uuid',
      breadcrumbName: '孵化器管理',
      childRoutes: [
        {
          path: 'detail',
          breadcrumbName: '孵化器管理',
          component: IncubatorOne,
          childRoutes: [
            {
              path: 'contract',
              breadcrumbName: '合同管理',
              component: IncubatorOneContract,
            },
            {
              path: 'bill',
              breadcrumbName: '账单管理',
              component: IncubatorOneBill,
            },
            {
              path: 'custom',
              breadcrumbName: '客户管理',
              component: IncubatorOneCustom,
            },
            {
              path: 'oregistapp',
              breadcrumbName: '地址管理',
              component: IncubatorOneOregistapp,
            },
            // {
            //   path: "finance",
            //   breadcrumbName: "财务分析",
            //   component: IncubatorOneFinance
            // }
          ],
        },
        {
          path: 'investment',
          breadcrumbName: '财务分析',
          component: IncubatorOneInvestment,
        },
        {
          path: 'analyze_income',
          component: AnalyzeIncome,
          breadcrumbName: '收入',
        },
        {
          path: 'expense',
          component: AnalyzeExpend,
          breadcrumbName: '支出',
        },
        {
          path: 'budget',
          component: AnalyzeBudget,
          breadcrumbName: '预算支出流水',
        },
        {
          path: 'trace',
          component: AnalyzeTrace,
          breadcrumbName: '利润追踪',
        },
        {
          path: 'other',
          component: AnalyzeOther,
          breadcrumbName: '非合同款',
        },
        {
          path: 'invoice',
          breadcrumbName: '开票',
          indexRoute: { component: InvoiceIndex },
          childRoutes: [
            {
              path: 'add',
              breadcrumbName: '开票申请',
              component: InvoiceAdd,
            },
            {
              path: ':customUuid/byCustom',
              breadcrumbName: '客户开票',
              component: Form.create({ wrappedComponentRef: true })(Manage),
            },
          ],
        },
        {
          path: 'contract',
          breadcrumbName: '合同管理',
          childRoutes: [
            {
              path: 'address',
              breadcrumbName: '添加地址合同',
              component: IncuContractAddress,
            },
            {
              path: 'station',
              breadcrumbName: '添加基础孵化合同',
              component: IncuContractStation,
            },
          ],
        },
        {
          path: 'income',
          breadcrumbName: '资金列表',
          indexRoute: { component: IncuIncomeList },
        },
        {
          path: 'refund',
          breadcrumbName: '错款退还',
          indexRoute: { component: RefundAdd },
        },
        {
          path: 'back',
          breadcrumbName: '账单退款',
          indexRoute: { component: BackAdd },
        },
        {
          path: 'discount',
          breadcrumbName: '折扣清单',
          component: PageIncuDiscount,
        },
      ],
    },
    {
      path: ':incubatorUuid/custom',
      breadcrumbName: '客户管理',
      indexRoute: { component: IncuCustomList },
      childRoutes: [
        {
          path: 'detail/:customUuid',
          breadcrumbName: '客户详情页',
          component: IncuCustomDetail,
        },
        {
          path: 'base/:customUuid',
          breadcrumbName: '客户基本情况',
          component: IncuCustomBase,
        },
      ],
    },
    {
      path: 'custom',
      breadcrumbName: '客户管理',
      indexRoute: { component: IncuCustomList },
      childRoutes: [
        {
          path: 'base/:customUuid',
          breadcrumbName: '客户基本情况',
          component: IncuCustomBase,
        },
      ],
    },
    {
      path: 'bill',
      breadcrumbName: '账单管理',
      indexRoute: { component: IncuBillList },
      childRoutes: [
        {
          path: ':uuid/detail',
          breadcrumbName: '账单详情',
          component: IncuBillDetail,
        },
        {
          path: ':uuid/back',
          breadcrumbName: '退款',
          component: BackAdd,
        },
      ],
    },
    {
      path: 'contract',
      breadcrumbName: '合同管理',
      indexRoute: { component: IncuContractList },
      childRoutes: [
        {
          path: 'address/add',
          breadcrumbName: '添加地址合同',
          component: IncuContractAddress,
        },
        {
          path: ':uuid/termination',
          breadcrumbName: '终止合同',
          component: contractTermination,
        },
        {
          path: ':uuid/termination/address',
          breadcrumbName: '终止合同',
          component: addressTermination,
        },
        {
          path: ':uuid/info',
          breadcrumbName: '合同详情',
          component: IncuContractInfo,
        },
        {
          path: ':uuid/address/info',
          breadcrumbName: '合同详情',
          component: IncuContractAddressInfo,
        },
        {
          path: ':uuid/other/info',
          breadcrumbName: '合同详情',
          component: IncuContractOtherInfo,
        },
        {
          path: 'address/:uuid/detail',
          breadcrumbName: '添加基础孵化合同',
          component: IncuContractStation,
        },
        {
          path: 'station/add',
          breadcrumbName: '添加基础孵化合同',
          component: IncuContractStation,
        },
        {
          path: 'station/:uuid/detail',
          breadcrumbName: '添加基础孵化合同',
          component: IncuContractStation,
        },
      ],
    },
    {
      path: 'base',
      breadcrumbName: '孵化器列表',
      indexRoute: { component: IncubatorList },
      childRoutes: [
        {
          path: 'add',
          breadcrumbName: '新增孵化器',
          component: IncubatorAdd,
        },
        {
          path: 'edit/:uuid',
          breadcrumbName: '编辑孵化器',
          component: IncubatorEdit,
        },
      ],
    },
    {
      path: 'seat/:uuid',
      breadcrumbName: '孵化器工位',
      indexRoute: { component: IncubatorSeatList },
    },
    {
      path: 'address/:uuid',
      breadcrumbName: '孵化器地址',
      indexRoute: { component: IncubatorAddressList },
    },
    {
      path: 'address/:addressUuid/release',
      breadcrumbName: '地址释放',
      indexRoute: { component: ReleaseAdd },
    },
    {
      path: 'addressed/:uuid',
      breadcrumbName: '孵化器地址使用明细',
      indexRoute: { component: IncubatorAddressedList },
    },
    {
      path: 'workbench',
      breadcrumbName: '工作台',
      indexRoute: { component: IncuContractWorkbench },
    },
    {
      path: 'setteled_manage',
      breadcrumbName: '我的入驻申请',
      indexRoute: { component: IncuSettledMine },
      childRoutes: [
        {
          path: 'open/:settledUuid',
          component: IncuSettledOpen,
          breadcrumbName: '查看入驻申请',
        },
      ],
    },
    {
      path: 'setteled_manage_watch',
      breadcrumbName: '入驻监控',
      indexRoute: { component: IncuSettledWatch },
    },
    {
      path: 'oregistapp_manage',
      breadcrumbName: '我的入驻申请',
      indexRoute: { component: IncuOregistappMine },
      childRoutes: [
        {
          path: 'open/:oregistappUuid',
          component: IncuOregistappOpen,
          breadcrumbName: '查看入驻申请',
        },
      ],
    },
    {
      path: 'oregistapp_manage_watch',
      breadcrumbName: '入驻监控',
      indexRoute: { component: IncuOregistappWatch },
    },
    {
      path: 'oregistappMoveOut_manage',
      breadcrumbName: '我的迁出申请',
      indexRoute: { component: IncuOregistappMoveOutMine },
      childRoutes: [
        {
          path: 'add/:uuid',
          component: IncuOregistappMoveOutAdd,
          breadcrumbName: '迁出申请',
        },
        {
          path: ':type/open/:uuid',
          component: IncuOregistappMoveOutOpen,
          breadcrumbName: '查看迁出申请',
        },
      ],
    },
    {
      path: 'oregistappMoveOut_manage_watch',
      breadcrumbName: '迁出监控',
      indexRoute: { component: IncuOregistappMoveOutWatch },
    },

    {
      path: 'termination_manage',
      breadcrumbName: '我的终止申请',
      indexRoute: { component: IncuTerminationMine },
      childRoutes: [
        {
          path: 'open/:terminationUuid',
          component: IncuTerminationOpen,
          breadcrumbName: '查看终止申请',
        },
      ],
    },
    {
      path: 'termination_manage_watch',
      breadcrumbName: '终止监控',
      indexRoute: { component: IncuTerminationWatch },
    },
    {
      path: 'back_manage',
      breadcrumbName: '我的退款申请',
      indexRoute: { component: IncuBackMine },
      childRoutes: [
        {
          path: 'open/:backUuid',
          component: IncuBackOpen,
          breadcrumbName: '查看退款申请',
        },
      ],
    },
    {
      path: 'back_manage_watch',
      breadcrumbName: '退款监控',
      indexRoute: { component: IncuBackWatch },
    },
    {
      path: 'release_manage',
      breadcrumbName: '我的地址释放申请',
      indexRoute: { component: IncuReleaseMine },
      childRoutes: [
        {
          path: 'open/:backUuid',
          component: IncuReleaseOpen,
          breadcrumbName: '查看地址释放申请',
        },
      ],
    },
    {
      path: 'release_manage_watch',
      breadcrumbName: '地址释放监控',
      indexRoute: { component: IncuReleaseWatch },
    },
    {
      path: 'refund_manage',
      breadcrumbName: '我的错看退还申请',
      indexRoute: { component: IncuRefundMine },
      childRoutes: [
        {
          path: 'open/:refundUuid',
          component: IncuRefundOpen,
          breadcrumbName: '查看错看退还申请',
        },
      ],
    },
    {
      path: 'refund_manage_watch',
      breadcrumbName: '错看退还监控',
      indexRoute: { component: IncuRefundWatch },
    },
    {
      path: 'invoice_manage',
      breadcrumbName: '我的开票申请',
      indexRoute: { component: IncuInvoiceMine },
      childRoutes: [
        {
          path: 'open/:invoiceUuid',
          component: IncuInvoiceOpen,
          breadcrumbName: '查看开票申请',
        },
      ],
    },
    {
      path: 'invoice_manage_watch',
      breadcrumbName: '开票监控',
      indexRoute: { component: IncuInvoiceWatch },
    },
    {
      path: 'analyze',
      breadcrumbName: '财务分析',
      childRoutes: [
        {
          path: 'income',
          component: AnalyzeIncome,
          breadcrumbName: '收入',
        },
        {
          path: 'expense',
          component: AnalyzeExpend,
          breadcrumbName: '支出',
        },
        {
          path: 'trace',
          component: AnalyzeTrace,
          breadcrumbName: '利润追踪',
        },
        {
          path: 'other',
          component: AnalyzeOther,
          breadcrumbName: '非合同款',
        },
      ],
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/incubator/router.js